'use client';

import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ThemeProvider} from 'next-themes';
import type {ReactNode} from 'react';

import {AppProvider} from '@/lib/contexts/Providers/AppProvider';

export type AppProvidersPropsT = {
  children: ReactNode;
};

const queryClient = new QueryClient();

function AppProviders({children}: AppProvidersPropsT) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="data-theme" defaultTheme="system" enableSystem>
        <AppProvider>{children}</AppProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default AppProviders;
